import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-121" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-122" data-mp="1dxji3e196zd1">
        <SectionHeading id="modules-title" data-id="element-123" data-mp="1dunhtj1xnylf">The {totalVolumes} <span className="text-accent" data-id="element-124" data-mp="2bj7ew01mfjp3">Professional Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-125" data-mp="26kw49n3i555t">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-primary/60 bg-surface p-6 shadow-lg shadow-black/30" data-id="element-126" data-mp="21nvx18ux1wd4" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-127" data-mp="1ns8wq7w6kvv2">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-accent/40 bg-background text-accent" data-id="element-128" data-mp="18w154mig0s5r">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="1dxyve0p9gn87" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-accent" data-id="element-130" data-mp="102o5l1pvisap">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-foreground" data-id="element-131" data-mp="q734r6wjjy2j">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-132" data-mp="v6pirik71ice">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}